import React, { useEffect } from "react";
import { useToastStore } from "../../stores/toast";

const TYPE_CLASSES = {
  error: "bg-danger text-white",
  success: "bg-success text-white",
  warning: "bg-warning text-dark",
  info: "bg-info text-white",
};

function Toast({ id, type, message }) {
  const removeToast = useToastStore((state) => state.removeToast);

  useEffect(() => {
    const timer = setTimeout(() => removeToast(id), 5000);
    return () => clearTimeout(timer);
  }, [id, removeToast]);

  return (
    <div
      className={`toast show ${TYPE_CLASSES[type] || TYPE_CLASSES.error}`}
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
    >
      <div className="d-flex">
        <div className="toast-body">{message}</div>
        <button
          type="button"
          className="btn-close btn-close-white me-2 m-auto"
          aria-label="Close"
          onClick={() => removeToast(id)}
        />
      </div>
    </div>
  );
}

export function ToastContainer() {
  const toasts = useToastStore((state) => state.toasts);

  return (
    <div
      className="toast-container position-fixed top-0 end-0 p-3"
      style={{ zIndex: 1090 }}
    >
      {toasts.map((toast) => (
        <Toast key={toast.id} {...toast} />
      ))}
    </div>
  );
}
